
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/basari-hikayeleri-gonder",
      function () {
        return require("private-next-pages/basari-hikayeleri-gonder.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/basari-hikayeleri-gonder"])
      });
    }
  